import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { z } from 'zod'
import { zodI18nMap } from 'zod-i18n-map'
import commonEN from './locales/en/common.json'
import translationEN from './locales/en/translation.json'
import zodEN from './locales/en/zod-en.json'
import commonES from './locales/es/common.json'
import translationES from './locales/es/translation.json'
import zodES from './locales/es/zod-es.json'
import commonFR from './locales/fr/common.json'
import translationFR from './locales/fr/translation.json'
import zodFR from './locales/fr/zod-fr.json'
import commonPT from './locales/pt/common.json'
import translationPT from './locales/pt/translation.json'
import zodPT from './locales/pt/zod-pt.json'

export enum Language {
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  PT = 'pt',
}

const resources = {
  en: {
    translation: translationEN,
    common: commonEN,
    zod: zodEN,
  },
  fr: {
    translation: translationFR,
    common: commonFR,
    zod: zodFR,
  },
  es: {
    translation: translationES,
    common: commonES,
    zod: zodES,
  },
  pt: {
    translation: translationPT,
    common: commonPT,
    zod: zodPT,
  },
}

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    resources,
    saveMissing: process.env.NODE_ENV !== 'production',
    missingKeyHandler: (lng, ns, key) => {
      if (ns === 'zod') return
      console.warn(`Missing Translation:`, {
        key,
        lng: lng.join(', '),
        jsonFile: ns,
      })
    },
    fallbackLng: Language.EN,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      defaultVariables: { prefix: '', suffix: '' }, // Global fallback values
    },
    ns: ['common', 'translation'],
    supportedLngs: [Language.EN, Language.FR, Language.ES, Language.PT],
  })

z.setErrorMap(zodI18nMap)
export { z }

export default i18n
